module.exports = __webpack_public_path__ + "assets/img/media-background.0ab7f529.png";